/**
 * 10Duke Entitlement API
 * 2.0.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "oazapfts/lib/runtime";
import * as QS from "oazapfts/lib/runtime/query";
export const defaults: Oazapfts.RequestOpts = {
    baseUrl: "https://entitlement.10duke.com",
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {
    server1: "https://entitlement.10duke.com"
};
export interface ResourceBase {
    id?: string;
}
export interface LicensedItems {
}
export type LicensedItem = ResourceBase & {
    name?: string;
    displayName?: string;
    description?: string;
    "type"?: string;
    aggregatedItems?: LicensedItems;
};
export interface ProductItem {
}
export interface ProductItems {
}
export interface ProductItemsRead extends ProductItems {
}
export type ApiError = {
    error: string;
    error_description?: string;
    error_uri?: string;
};
export type LicenseProvisioningRequest = object;
export type LicenseContractReference = {
    "type": string;
    externalContractId: string;
};
export type ResourceWithValidity = ResourceBase & {
    validFrom?: string;
    validUntil?: string;
};
export type LicenseCreditConsumptionSettings = {
    allowedOveruse?: string;
    "type": string;
};
export type LicenseAssignmentConstraints = {
    anchors?: ("user" | "device")[];
    reservations?: "advance" | "lazy" | "optional";
    reassignments?: "unlimited" | "limited" | "prohibited";
    maxCount?: number;
};
export type ModeSpecificLicenseSessionConstraints = {
    maxCount?: number;
};
export type TotalLicenseSessionConstraints = {
    maxCount?: number;
};
export type LicenseSessionConstraints = {
    anchors?: ("device" | "resource")[];
    online?: ModeSpecificLicenseSessionConstraints;
    offline?: ModeSpecificLicenseSessionConstraints;
    total?: TotalLicenseSessionConstraints;
};
export type LeaseExtensionConstraints = {
    allowed?: boolean;
    authorization?: "leaseId" | "optionalLeaseId" | "none";
};
export type LeaseReleaseConstraints = {
    allow?: boolean;
    cooldown?: number;
};
export type ModeSpecificLicenseLeaseConstraints = {
    maxLeaseTime?: number;
    extension?: LeaseExtensionConstraints;
    release?: LeaseReleaseConstraints;
};
export type LicenseLeaseConstraints = {
    anchors?: "process"[];
    online?: ModeSpecificLicenseLeaseConstraints;
    offline?: ModeSpecificLicenseLeaseConstraints;
};
export type LicenseModel = ResourceBase & {
    name?: string;
    description?: string;
    credits?: LicenseCreditConsumptionSettings;
    assignments?: LicenseAssignmentConstraints;
    sessions?: LicenseSessionConstraints;
    leases?: LicenseLeaseConstraints;
    locking?: "none" | "exclusive";
    versions?: "allowAll" | "constrain";
};
export type EffectiveLicenseModel = LicenseModel;
export type LicenseScope = {
    "type"?: string;
    externalId?: string;
    externalName?: string;
};
export interface LicenseScopes {
}
export type License = ResourceWithValidity & {
    active?: boolean;
    entitlementId?: string;
    licensedItem?: LicensedItem;
    licenseModelId?: string;
    licenseModelName?: string;
    effectiveLicenseModel?: EffectiveLicenseModel;
    scopeBindings?: LicenseScopes;
    seatsTaken?: number;
    seatsReserved?: number;
    seatsTotal?: number;
};
export type LicenseCreditBase = ResourceWithValidity & {
    active?: boolean;
    licenseId?: string;
    licenseTransactionItemId?: string;
    objectType?: string;
};
export type VersionConstrainedScopedLicenseCreditBase = LicenseCreditBase & {
    allowedVersions?: string;
    allowedVersionsDescription?: string;
    scopeBindings?: LicenseScopes;
};
export type SeatCountCredit = VersionConstrainedScopedLicenseCreditBase & {
    seatCount?: number;
    seatsConsumed?: number;
};
export interface SeatCountCredits {
}
export type SeatReservationCredit = LicenseCreditBase & {
    seatReservationCount?: number;
    seatReservationsConsumed?: number;
};
export interface SeatReservationCredits {
}
export type UseCountCredit = VersionConstrainedScopedLicenseCreditBase & {
    useCount?: number;
    countUsed?: number;
};
export interface UseCountCredits {
}
export type UseTimeCredit = VersionConstrainedScopedLicenseCreditBase & {
    useTime?: number;
    timeUsed?: number;
};
export interface UseTimeCredits {
}
export interface LicenseWithCredits {
}
export interface LicensesWithCredits {
}
export type LicenseTransactionItem = ResourceBase & {
    externalId?: string;
    productId?: string;
    quantity?: number;
    licenseValidFrom?: string;
    licenseValidUntil?: string;
    licenses?: LicensesWithCredits;
};
export type LicenseTransaction = ResourceBase & {
    "type"?: string;
    externalId?: string;
    processed?: string;
    contract?: LicenseContractReference;
    items?: LicenseTransactionItem[];
};
export type LicenseTransactionRequest = LicenseProvisioningRequest & {
    transaction?: LicenseTransaction;
};
export type LicenseProvisioningResult = object;
export type LicenseTransactionProcessingResult = LicenseProvisioningResult & {
    transaction?: LicenseTransaction;
};
export type LicenseRevokeResult = object;
export type LicenseTransactionCancelResult = LicenseRevokeResult & {
    transaction?: LicenseTransaction;
};
export type Entitlement = ResourceBase & {
    "type"?: string;
    name?: string;
    description?: string;
    isDefault?: boolean;
};
export type OrganizationGroup = ResourceBase & {
    organizationId?: string;
    name?: string;
    "type"?: string;
    description?: string;
};
export type IncludeLicenseCredits = "all" | "valid" | "latestExpiration";
export interface LicensesWithCreditsRead extends LicensesWithCredits {
}
export type UserIdentityBase = ResourceBase & {
    displayName?: string;
};
export type UserProfile = UserIdentityBase & {
    email?: string;
    firstName?: string;
    lastName?: string;
    nickname?: string;
    phoneNumber?: string;
    professionalTitle?: string;
};
export type LicenseAssignment = ResourceWithValidity & {
    "type"?: "reserved" | "denied" | "floating";
};
export type ExternalEntityReference = {
    "type"?: string;
    externalId?: string;
    externalName?: string;
};
export type LicenseLeaseAnchor = ExternalEntityReference;
export interface LicenseLeaseAnchors {
}
export interface LicenseLease {
}
export interface LicenseLeases {
}
export type LicenseSessionAnchor = ResourceBase & ExternalEntityReference;
export interface LicenseSessionAnchors {
}
export interface LicenseSession {
}
export interface LicenseSessions {
}
export interface LicenseAssignmentWithSessions {
}
export type LicenseAssignmentsWithSessions = LicenseAssignmentWithSessions[];
export interface UserProfileWithAssignmentsAndSessions {
}
export type TechnicalActor = UserIdentityBase & {
    username?: string;
};
export interface TechnicalUserWithAssignmentsAndSessions {
}
export type LicenseUsersWithAssignmentsAndSessions = (({
    objectType: "User";
} & UserProfileWithAssignmentsAndSessions) | ({
    objectType: "TechnicalUser";
} & TechnicalUserWithAssignmentsAndSessions))[];
export interface LicenseUsage {
}
export interface LicenseUsageRead extends LicenseUsage {
}
export type LicenseAssignments = LicenseAssignment[];
export type Organization = ResourceBase & {
    name?: string;
    "type"?: string;
    description?: string;
};
export interface LicenseOwner {
}
export interface LicenseWithOwner {
}
export interface LicenseWithOwnerAndSingleUserAssignments {
}
export interface LicensesWithOwnerAndSingleUserAssignments {
}
export interface LicensesWithOwnerAndSingleUserAssignmentsRead extends LicensesWithOwnerAndSingleUserAssignments {
}
export type LicenseActivationRequest = {
    grantType: string;
    acceptLocalizedAgreementIds?: string[];
    declineLocalizedAgreementIds?: string[];
};
export interface LicenseWithCreditsRead extends LicenseWithCredits {
}
/**
 * Gets product items of product(s)
 */
export function getProductItems(productId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: ProductItemsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/products/${encodeURIComponent(productId)}/product-items`, {
        ...opts
    });
}
/**
 * Fulfills a new license transaction
 */
export function processLicenseTransaction(orgId: string, licenseTransactionRequest: LicenseTransactionRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionProcessingResult;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/license-transactions`, oazapfts.json({
        ...opts,
        method: "POST",
        body: licenseTransactionRequest
    }));
}
/**
 * Updates existing license transaction
 */
export function changeLicenseTransaction(orgId: string, licenseTransactionRequest: LicenseTransactionRequest, { allowDeleteLicenses }: {
    allowDeleteLicenses?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionProcessingResult;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/license-transactions${QS.query(QS.explode({
        allowDeleteLicenses
    }))}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: licenseTransactionRequest
    }));
}
/**
 * Gets a license transaction
 */
export function getLicenseTransaction(orgId: string, transactionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransaction;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/license-transactions/${encodeURIComponent(transactionId)}`, {
        ...opts
    });
}
/**
 * Cancels a license transaction
 */
export function cancelLicenseTransaction(orgId: string, transactionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionCancelResult;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/license-transactions/${encodeURIComponent(transactionId)}/cancel`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Lists entitlements of the organization
 */
export function listOrganizationEntitlements(orgId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Entitlement[];
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements`, {
        ...opts
    });
}
/**
 * Adds a new entitlement for the organization
 */
export function addOrganizationEntitlement(orgId: string, entitlement: Entitlement, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
        data: Entitlement;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements`, oazapfts.json({
        ...opts,
        method: "POST",
        body: entitlement
    }));
}
/**
 * Gets an entitlement of the organization
 */
export function getOrganizationEntitlement(orgId: string, entId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Entitlement;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}`, {
        ...opts
    });
}
/**
 * Updates organization entitlement
 */
export function updateOrganizationEntitlement(orgId: string, entId: string, entitlement: Entitlement, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Entitlement;
    } | {
        status: 403;
        data: ApiError;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: entitlement
    }));
}
/**
 * Deletes the entitlement
 */
export function deleteOrganizationEntitlement(orgId: string, entId: string, { moveLicensesToDefaultEntitlement }: {
    moveLicensesToDefaultEntitlement?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 204;
    } | {
        status: 403;
        data: ApiError;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}${QS.query(QS.explode({
        moveLicensesToDefaultEntitlement
    }))}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Gets groups that have been added as consumers of licenses of the entitlement
 */
export function listLicenseConsumingOrgGroups(orgId: string, entId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationGroup[];
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-groups`, {
        ...opts
    });
}
/**
 * Replaces current license consumer groups
 */
export function setLicenseConsumingOrgGroups(orgId: string, entId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-groups`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Adds a group as a consumer of licenses of the entitlement
 */
export function addLicenseConsumingOrgGroup(orgId: string, entId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-groups/${encodeURIComponent(groupId)}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Removes a group from consumers of the entitlement
 */
export function removeLicenseConsumingOrgGroup(orgId: string, entId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/consuming-groups/${encodeURIComponent(groupId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Adds an entitlement for organization group to consume
 */
export function addEntitlementConsumedByOrgGroup(orgId: string, entId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/groups/${encodeURIComponent(groupId)}/consumed-entitlements/${encodeURIComponent(entId)}`, {
        ...opts,
        method: "POST"
    });
}
/**
 * Removes a group from consumers of the entitlement
 */
export function removeEntitlementConsumedByOrgGroup(orgId: string, entId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/groups/${encodeURIComponent(groupId)}/consumed-entitlements/${encodeURIComponent(entId)}`, {
        ...opts,
        method: "DELETE"
    });
}
/**
 * Gets entitlements that group can consume licenses of
 */
export function listEntitlementsConsumedByOrgGroup(orgId: string, groupId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: Entitlement[];
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/groups/${encodeURIComponent(groupId)}/consumed-entitlements`, {
        ...opts
    });
}
/**
 * Replaces entitlements consumed by organization groups
 */
export function setEntitlementsConsumedByOrgGroup(orgId: string, groupId: string, body: string[], opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 201;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/groups/${encodeURIComponent(groupId)}/consumed-entitlements`, oazapfts.json({
        ...opts,
        method: "PUT",
        body
    }));
}
/**
 * Lists licenses of the entitlement
 */
export function listEntitlementLicenses(orgId: string, entId: string, { includeCredits, includeEffectiveModel }: {
    includeCredits?: IncludeLicenseCredits;
    includeEffectiveModel?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicensesWithCreditsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses${QS.query(QS.explode({
        includeCredits,
        includeEffectiveModel
    }))}`, {
        ...opts
    });
}
/**
 * Gets current usage of the license
 */
export function queryLicenseUsage(orgId: string, entId: string, licenseId: string, { includeEffectiveModel }: {
    includeEffectiveModel?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseUsageRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/usage${QS.query(QS.explode({
        includeEffectiveModel
    }))}`, {
        ...opts
    });
}
/**
 * Gets user's assignments to the license
 */
export function getLicenseAssignments(orgId: string, entId: string, licenseId: string, userId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseAssignments;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/users/${encodeURIComponent(userId)}/assignments`, {
        ...opts
    });
}
/**
 * Manages user's license assigments
 */
export function manageLicenseAssignments(orgId: string, entId: string, licenseId: string, userId: string, licenseAssignments: LicenseAssignments, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseAssignments;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/users/${encodeURIComponent(userId)}/assignments`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: licenseAssignments
    }));
}
/**
 * Gets licenses that are available to the user
 */
export function queryAvailableLicenses(userId: string, { version, product, ownerOrganizationId, includeCredits, includeEffectiveModel, includeAggregatedLicensedItems, onlyValidLicenses }: {
    version?: string;
    product?: string;
    ownerOrganizationId?: string;
    includeCredits?: IncludeLicenseCredits;
    includeEffectiveModel?: boolean;
    includeAggregatedLicensedItems?: boolean;
    onlyValidLicenses?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicensesWithOwnerAndSingleUserAssignmentsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/available-licenses${QS.query(QS.explode({
        version,
        product,
        ownerOrganizationId,
        includeCredits,
        includeEffectiveModel,
        includeAggregatedLicensedItems,
        onlyValidLicenses
    }))}`, {
        ...opts
    });
}
/**
 * Handles license activation request and provisions licenses for user
 */
export function activateUserLicenses(userId: string, licenseActivationRequest: LicenseActivationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionProcessingResult;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/activate-licenses`, oazapfts.json({
        ...opts,
        method: "POST",
        body: licenseActivationRequest
    }));
}
/**
 * Fulfills a new license transaction
 */
export function processUserLicenseTransaction(userId: string, licenseTransactionRequest: LicenseTransactionRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionProcessingResult;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/license-transactions`, oazapfts.json({
        ...opts,
        method: "POST",
        body: licenseTransactionRequest
    }));
}
/**
 * Updates existing license transaction
 */
export function changeUserLicenseTransaction(userId: string, licenseTransactionRequest: LicenseTransactionRequest, { allowDeleteLicenses }: {
    allowDeleteLicenses?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionProcessingResult;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/license-transactions${QS.query(QS.explode({
        allowDeleteLicenses
    }))}`, oazapfts.json({
        ...opts,
        method: "PUT",
        body: licenseTransactionRequest
    }));
}
/**
 * Gets a license transaction
 */
export function getUserLicenseTransaction(userId: string, transactionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransaction;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/license-transactions/${encodeURIComponent(transactionId)}`, {
        ...opts
    });
}
/**
 * Cancels a license transaction
 */
export function cancelUserLicenseTransaction(userId: string, transactionId: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionCancelResult;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/users/${encodeURIComponent(userId)}/license-transactions/${encodeURIComponent(transactionId)}/cancel`, {
        ...opts,
        method: "PUT"
    });
}
/**
 * Handles license activation request and provisions licenses for organization
 */
export function activateOrganizationLicenses(orgId: string, licenseActivationRequest: LicenseActivationRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseTransactionProcessingResult;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/activate-licenses`, oazapfts.json({
        ...opts,
        method: "POST",
        body: licenseActivationRequest
    }));
}
/**
 * Moves license
 */
export function moveLicense(orgId: string, entId: string, licenseId: string, destEntId: string, { includeCredits, includeEffectiveModel }: {
    includeCredits?: IncludeLicenseCredits;
    includeEffectiveModel?: boolean;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: LicenseWithCreditsRead;
    } | {
        status: 404;
        data: ApiError;
    } | {
        status: 409;
        data: ApiError;
    } | {
        status: number;
        data: ApiError;
    }>(`/organizations/${encodeURIComponent(orgId)}/entitlements/${encodeURIComponent(entId)}/licenses/${encodeURIComponent(licenseId)}/move/${encodeURIComponent(destEntId)}${QS.query(QS.explode({
        includeCredits,
        includeEffectiveModel
    }))}`, {
        ...opts,
        method: "PUT"
    });
}
